"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInitials = getInitials;
exports.SiteMenuAvatar = void 0;

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _blocks = require("@bueno/blocks");

// Code yoinked from Blocks
const Container = _styledComponents.default.div`
  // Blocks
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  padding: 0;

  border: 0;
  /* TODO - this should be configurable when using an instance
  of the Avatar component and be 'transparent' by default */
  background-color: ${_blocks.color.theme.primaryNav.state.currentActive};

  color: ${_blocks.color.pureWhite};
  ${_blocks.typography.displaySmall}
  font-weight: ${_blocks.fontWeight.bold};

  &:hover {
    cursor: pointer;
  }

  &:active,
  &:focus {
    outline: none;
  }

  svg {
    fill: ${_blocks.color.pureWhite};
  }

  // Site Menu
  min-width: 34px;
  min-height: 34px;
  width: 34px;
  height: 34px;
  background: none;
  /* neutral dark 8 */
  box-shadow: inset 0 0 0 1px hsl(207, 5.6%, 31.6%);
`;

/**
 * Return up to 3 initials from a name
 * @param name
 */
function getInitials(name) {
  return name.split(' ').slice(0, 3).map(w => {
    var _w$;

    return (_w$ = w[0]) === null || _w$ === void 0 ? void 0 : _w$.toUpperCase();
  }).join('');
}

const SiteMenuAvatar = ({
  name,
  icon,
  ...rest
}) => {
  if (name !== undefined && icon !== undefined || name === undefined && icon === undefined) {
    throw Error('Avatar expects one of "name" or "icon"');
  }

  return /*#__PURE__*/React.createElement(Container, rest, name !== undefined && getInitials(name), icon);
};

exports.SiteMenuAvatar = SiteMenuAvatar;